import React from 'react'
import {AccordionTrigger} from 'hec/components/ui/accordion'
import {useAccordionContext} from './accordionContext'

interface CustomAccordionTitleProps {
    className?: string
    renderContent?: () => React.ReactNode
}

export const CustomAccordionTitle: React.FC<CustomAccordionTitleProps> = ({
    className,
    renderContent,
    ...props
}) => {
    const {arrowDirection, highlightExpandedItem} = useAccordionContext()

    return (
        <AccordionTrigger
            className={className}
            {...props}
            arrowDirection={arrowDirection}
            highlightExpandedItem={highlightExpandedItem}
            data-testid="accordionTitle-AccordionTrigger"
        >
            {renderContent?.()}
        </AccordionTrigger>
    )
}
